module.exports = __webpack_public_path__ + "static/media/user9.458c83ae.gif";